import { asContainer } from 'lib/container'

import type { AsyncContainer } from './AsyncContainer'

type State = {
	asyncModule: { AsyncContainer: typeof AsyncContainer }
}

export const container = asContainer<State>()({
	path: '/demo',
	initialize: async () => ({
		asyncModule: await import('./AsyncContainer'),
	}),
	Running: ({ query, asyncModule }) => (
		<asyncModule.AsyncContainer path={typeof query?.path === 'string' ? query.path : '/car-insurance'} />
	),
})
